import * as React from 'react';

// Types
import { IQuestion } from './AppNetworkQuestions';

// Components
import { FancyAvatar } from '../../components/Avatar';
import { ModifiedBadge } from '../../components/Badge';
import Button from '../../components/Button';
import Card, {
  CardHeader,
  CardContent,
  CardActions
} from '../../components/Card';
import Divider from '../../components/Divider';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import Typography from '../../components/Typography';

// Style
import './QuestionCard.css';

// Component
interface IProps {
  question: IQuestion;
  onOpen: (questionId: IQuestion) => void;
  onRequestComment: () => void;
}

function QuestionCard(props: IProps) {
  // const answeredRecipients = props.question.options
  //   .map(item => item.recipientCount)
  //   .reduce((pv, cv) => pv + cv, 0);
  // const pendingRecipients = props.question.recipientCount - answeredRecipients;

  return (
    <Card className="AppNetworkQuestion__QuestionCard">
      <CardHeader
        avatar={
          <FancyAvatar
            src={props.question.authorPhotoUrl}
            text={`${props.question.authorFirstName} ${
              props.question.authorLastName
            }`}
          />
        }
        title={`${props.question.authorFirstName} ${
          props.question.authorLastName
        }`}
        subheader={props.question.networkName}
      />
      <Divider />
      <CardContent>
        <Typography type="headline">{props.question.description}</Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Button onClick={() => props.onOpen(props.question)}>
          Show Question
        </Button>
        <span style={{ flexGrow: 1 }} />
        <IconButton onClick={props.onRequestComment}>
          {props.question.commentCount === 0 ? (
            <Icon>comment</Icon>
          ) : (
            <ModifiedBadge
              badgeContent={props.question.commentCount}
              color="primary"
            >
              <Icon>comment</Icon>
            </ModifiedBadge>
          )}
        </IconButton>
      </CardActions>
    </Card>
  );
}

// Exports
export default QuestionCard;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkQuestions/QuestionCard.tsx